import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button, Form, Input, notification, Row, Col, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useAuth } from "context/providers/auth";
import { handleErrors } from "helpers/api";

import { password_regexp } from "helpers/regexp";
import useGet from "hooks/useGet";
import AuthLayout from "components/AuthLayout";

const UserInvitation = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { is_loading, data } = useGet({
    query: ["worker_invitations", id],
    path: `/worker_invitations/${id}/public`,
    error_message: "Nie znaleziono zaproszenia.",
    onError: () => navigate("/"),
  });
  const [is_saving, setSaving] = useState(false);
  const { handleConfirmInvitation } = useAuth();

  const onFinish = async (values) => {
    try {
      setSaving(true);
      await handleConfirmInvitation({ worker_invitation_id: id, ...values });
    } catch (error) {
      notification.error({ message: handleErrors(error) });
    } finally {
      setSaving(false);
    }
  };

  return (
    <AuthLayout title="Zaproszenie">
      {is_loading ? (
        <div className="auth-page__loader">
          <Spin indicator={<LoadingOutlined spin style={{ fontSize: 68 }} />} />
        </div>
      ) : (
        <div className="auth-page__form">
          <p>
            Witaj <strong>{data?.first_name}</strong>!
          </p>
          <p>
            Firma <strong>{data?.company?.name}</strong> wysłała Ci zaproszenie
            do grona adminstratorów.
          </p>
          <p>Możesz do niej dołączyć wypełniając poniższy formularz.</p>
          <Form
            className="m-t-20"
            name="basic"
            initialValues={{
              password: "",
              password_confirmation: "",
            }}
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
          >
            <Row gutter={[12, 12]}>
              <Col xs={24} md={24} lg={12} xl={12}>
                <Form.Item
                  label="Hasło"
                  name="password"
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: "Hasło jest wymagane!",
                    },
                    {
                      max: 128,
                      message: "Przekroczono maksymalną ilość znaków!",
                    },
                    {
                      min: 8,
                      message: "Hasło musi mieć co najmniej 8 znaków!",
                    },
                    {
                      pattern: password_regexp,
                      message:
                        "Hasło musi zawierać przynajmniej jedną dużą literę, jedną cyfrę i jeden znak specjalny!",
                    },
                  ]}
                >
                  <Input.Password maxLength={128} />
                </Form.Item>
              </Col>
              <Col xs={24} md={24} lg={12} xl={12}>
                <Form.Item
                  label="Potwierdź hasło"
                  name="password_confirmation"
                  dependencies={["password"]}
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: "Potwierdzenie hasła jest wymagane!",
                    },

                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Hasła muszą być takie same!")
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password maxLength={128} />
                </Form.Item>
              </Col>
            </Row>
            <Button
              loading={is_saving}
              disabled={is_saving}
              type="primary"
              htmlType="submit"
              block
              size="large"
            >
              Zarejestruj się
            </Button>
          </Form>
        </div>
      )}
      <div className="auth-page__links">
        <Link href="/">Wróć do logowania</Link>
      </div>
    </AuthLayout>
  );
};

export default UserInvitation;
